import { client } from '../utils/contentful.js';

export const getHomepageData = () => {
    const data = client.getEntries({
        content_type: 'homepage',
        include: 6
    });
    return data
}


export const getNavigationData = () => {
    const data = client
        .getEntries({
            content_type: 'navigation'
        })
    return data;
}


// WEBPACK FOOTER //
// ./src/Queries/index.js